
// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchAttendance } from "../redux/actions/attendanceActions";

// const Attendance = () => {
//   const dispatch = useDispatch();
//   const { attendance, loading, error } = useSelector((state) => state.attendance);

//   const [photoModalOpen, setPhotoModalOpen] = useState(false);
//   const [photoUrl, setPhotoUrl] = useState("");
//   const [searchName, setSearchName] = useState("");
//   const [searchPhone, setSearchPhone] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   const itemsPerPage = 10;

//   useEffect(() => {
//     dispatch(fetchAttendance());
//   }, [dispatch]);

//   const openPhotoModal = (url) => {
//     setPhotoUrl(url);
//     setPhotoModalOpen(true);
//   };

//   const closePhotoModal = () => {
//     setPhotoModalOpen(false);
//     setPhotoUrl("");
//   };

//   const filteredAttendance = attendance.filter((att) => {
//     const matchName = att.employee_name?.toLowerCase().includes(searchName.toLowerCase());
//     const matchPhone = att.employee_phone?.includes(searchPhone);
//     let matchFromDate = true;
//     let matchToDate = true;

//     if (fromDate) matchFromDate = new Date(att.date) >= new Date(fromDate);
//     if (toDate) matchToDate = new Date(att.date) <= new Date(toDate);

//     return matchName && matchPhone && matchFromDate && matchToDate;
//   });

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredAttendance.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredAttendance.length / itemsPerPage);

//   const handleNext = () => {
//     if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//   };

//   const handlePrevious = () => {
//     if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//   };

//   const resetDates = () => {
//     setFromDate("");
//     setToDate("");
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     const options = {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//       timeZone: "Asia/Kolkata",
//     };
//     return new Date(dateStr).toLocaleString("en-IN", options);
//   };

//   return (
//     <div className="w-full h-auto bg-gray-100 p-4">
//       <h1 className="text-2xl font-bold mb-4">Attendance Records</h1>

//       {/* Filters */}
//       <div className="flex flex-wrap gap-2 mb-4 items-center justify-start">
//         <input
//           type="text"
//           placeholder="Search by Name"
//           value={searchName}
//           onChange={(e) => {
//             setSearchName(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         />
//         <input
//           type="text"
//           placeholder="Search by Phone"
//           value={searchPhone}
//           onChange={(e) => {
//             setSearchPhone(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         />
//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => {
//             setFromDate(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         />
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => {
//             setToDate(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         />
//         <button
//           onClick={resetDates}
//           className="px-3 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
//         >
//           Reset Date
//         </button>
//       </div>

//       {loading && <p>Loading attendance...</p>}
//       {error && <p className="text-red-600">Error: {error}</p>}

//       {filteredAttendance.length > 0 ? (
//         <div className="bg-white rounded-lg shadow-lg overflow-auto max-w-full">
//           <table className="min-w-[1200px] w-full text-sm">
//             <thead className="bg-black text-white">
//               <tr>
//                 <th className="px-4 py-2">ID</th>
//                 <th className="px-4 py-2">Date</th>
//                 <th className="px-4 py-2">Check-In Time</th>
//                 <th className="px-4 py-2">Check-In Lat</th>
//                 <th className="px-4 py-2">Check-In Long</th>
//                 <th className="px-4 py-2">Check-In Address</th>
//                 <th className="px-4 py-2">Check-In Photo</th>
//                 <th className="px-4 py-2">Check-Out Time</th>
//                 <th className="px-4 py-2">Check-Out Lat</th>
//                 <th className="px-4 py-2">Check-Out Long</th>
//                 <th className="px-4 py-2">Check-Out Address</th>
//                 <th className="px-4 py-2">Check-Out Photo</th>
//                 {/* <th className="px-4 py-2">Status</th> */}
//                 <th className="px-4 py-2">Remarks</th>
//                 {/* <th className="px-4 py-2">Created At</th> */}
//                 <th className="px-4 py-2">Employee Name</th>
//                 <th className="px-4 py-2">Employee Phone</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {currentItems.map((att) => (
//                 <tr key={att.id} className="hover:bg-gray-50">
//                   <td className="px-4 py-2">{att.id}</td>
//                   <td className="px-4 py-2">{formatDate(att.date)}</td>
//                   <td className="px-4 py-2">{att.check_in}</td>
//                   <td className="px-4 py-2">{att.check_in_latitude}</td>
//                   <td className="px-4 py-2">{att.check_in_longitude}</td>
//                   <td className="px-4 py-2">{att.check_in_address}</td>
//                   <td className="px-4 py-2">
//                     {att.check_in_photo ? (
//                       <button
//                         className="text-blue-600 underline"
//                         onClick={() => openPhotoModal(att.check_in_photo)}
//                       >
//                         View
//                       </button>
//                     ) : (
//                       "-"
//                     )}
//                   </td>
//                   <td className="px-4 py-2">{att.check_out || "-"}</td>
//                   <td className="px-4 py-2">{att.check_out_latitude || "-"}</td>
//                   <td className="px-4 py-2">{att.check_out_longitude || "-"}</td>
//                   <td className="px-4 py-2">{att.check_out_address || "-"}</td>
//                   <td className="px-4 py-2">
//                     {att.check_out_photo ? (
//                       <button
//                         className="text-blue-600 underline"
//                         onClick={() => openPhotoModal(att.check_out_photo)}
//                       >
//                         View
//                       </button>
//                     ) : (
//                       "-"
//                     )}
//                   </td>
//                    {/* <td className="px-4 py-2 capitalize">{att.status}</td> */}
//                    <td className="px-4 py-2">{att.remarks}</td> 
//                    {/* <td className="px-4 py-2">{formatDate(att.created_at)}</td>  */}
//                   <td className="px-4 py-2">{att.employee_name}</td>
//                   <td className="px-4 py-2">{att.employee_phone}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="flex justify-between items-center p-4 border-t">
//             <button
//               onClick={handlePrevious}
//               disabled={currentPage === 1}
//               className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
//             >
//               Previous
//             </button>
//             <p className="text-sm">
//               Page {currentPage} of {totalPages}
//             </p>
//             <button
//               onClick={handleNext}
//               disabled={currentPage === totalPages}
//               className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       ) : (
//         !loading && <p>No attendance records found.</p>
//       )}

//       {photoModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-4 rounded shadow-lg relative max-w-sm">
//             <button
//               onClick={closePhotoModal}
//               className="absolute top-2 right-2 text-gray-600 hover:text-black"
//             >
//               ✖
//             </button>
//             <img
//               src={photoUrl}
//               alt="Attendance"
//               className="w-full h-auto max-h-[80vh] object-contain"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Attendance;


import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchAttendance } from "../redux/actions/attendanceActions";

const Attendance = () => {
  const dispatch = useDispatch();
  const { attendance, loading, error } = useSelector((state) => state.attendance);

  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [photoUrl, setPhotoUrl] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(fetchAttendance());
  }, [dispatch]);

  const openPhotoModal = (url) => {
    setPhotoUrl(url);
    setPhotoModalOpen(true);
  };

  const closePhotoModal = () => {
    setPhotoModalOpen(false);
    setPhotoUrl("");
  };

  const filteredAttendance = attendance.filter((att) => {
    const matchName = att.employee_name?.toLowerCase().includes(searchName.toLowerCase());
    const matchPhone = att.employee_phone?.includes(searchPhone);
    let matchFromDate = true;
    let matchToDate = true;

    if (fromDate) matchFromDate = new Date(att.date) >= new Date(fromDate);
    if (toDate) matchToDate = new Date(att.date) <= new Date(toDate);

    return matchName && matchPhone && matchFromDate && matchToDate;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAttendance.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredAttendance.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const resetDates = () => {
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
  };

  const formatDate = (dateStr) => {
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Asia/Kolkata",
    };
    return new Date(dateStr).toLocaleString("en-IN", options);
  };

  return (
    <div className="w-full h-auto bg-gray-100 p-4">
      <h1 className="text-2xl font-bold mb-4">Attendance Records</h1>

      {/* Filters */}
      <div className="flex flex-wrap gap-2 mb-4 items-center justify-start">
        <input
          type="text"
          placeholder="Search by Name"
          value={searchName}
          onChange={(e) => {
            setSearchName(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        />
        <input
          type="text"
          placeholder="Search by Phone"
          value={searchPhone}
          onChange={(e) => {
            setSearchPhone(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        />
        <input
          type="date"
          value={fromDate}
          onChange={(e) => {
            setFromDate(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => {
            setToDate(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        />
        <button
          onClick={resetDates}
          className="px-3 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
        >
          Reset Date
        </button>
      </div>

      {/* Error Message Styled Same as Leaves */}
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
          Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
        </div>
      )}

      {loading && <p>Loading attendance...</p>}

      {!loading && filteredAttendance.length > 0 ? (
        <div className="bg-white rounded-lg shadow-lg overflow-auto max-w-full">
          <table className="min-w-[1200px] w-full text-sm">
            <thead className="bg-black text-white">
              <tr>
                <th className="px-4 py-2">ID</th>
                <th className="px-4 py-2">Date</th>
                <th className="px-4 py-2">Check-In Time</th>
                <th className="px-4 py-2">Check-In Lat</th>
                <th className="px-4 py-2">Check-In Long</th>
                <th className="px-4 py-2">Check-In Address</th>
                <th className="px-4 py-2">Check-In Photo</th>
                <th className="px-4 py-2">Check-Out Time</th>
                <th className="px-4 py-2">Check-Out Lat</th>
                <th className="px-4 py-2">Check-Out Long</th>
                <th className="px-4 py-2">Check-Out Address</th>
                <th className="px-4 py-2">Check-Out Photo</th>
                <th className="px-4 py-2">Remarks</th>
                <th className="px-4 py-2">Employee Name</th>
                <th className="px-4 py-2">Employee Phone</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentItems.map((att) => (
                <tr key={att.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{att.id}</td>
                  <td className="px-4 py-2">{formatDate(att.date)}</td>
                  <td className="px-4 py-2">{att.check_in}</td>
                  <td className="px-4 py-2">{att.check_in_latitude}</td>
                  <td className="px-4 py-2">{att.check_in_longitude}</td>
                  <td className="px-4 py-2">{att.check_in_address}</td>
                  <td className="px-4 py-2">
                    {att.check_in_photo ? (
                      <button
                        className="text-blue-600 underline"
                        onClick={() => openPhotoModal(att.check_in_photo)}
                      >
                        View
                      </button>
                    ) : "-"}
                  </td>
                  <td className="px-4 py-2">{att.check_out || "-"}</td>
                  <td className="px-4 py-2">{att.check_out_latitude || "-"}</td>
                  <td className="px-4 py-2">{att.check_out_longitude || "-"}</td>
                  <td className="px-4 py-2">{att.check_out_address || "-"}</td>
                  <td className="px-4 py-2">
                    {att.check_out_photo ? (
                      <button
                        className="text-blue-600 underline"
                        onClick={() => openPhotoModal(att.check_out_photo)}
                      >
                        View
                      </button>
                    ) : "-"}
                  </td>
                  <td className="px-4 py-2">{att.remarks}</td>
                  <td className="px-4 py-2">{att.employee_name}</td>
                  <td className="px-4 py-2">{att.employee_phone}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-between items-center p-4 border-t">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Previous
            </button>
            <p className="text-sm">Page {currentPage} of {totalPages}</p>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        !loading && !error && <p>No attendance records found.</p>
      )}

      {/* Photo Modal */}
      {photoModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded shadow-lg relative max-w-sm">
            <button
              onClick={closePhotoModal}
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
            >
              ✖
            </button>
            <img
              src={photoUrl}
              alt="Attendance"
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Attendance;
